import catalogRedux from '../../catalog/redux/slice'
import viewContactRedux from '../../modals/viewContact/redux/slice'

//export redux objects
export default {
	catalogRedux,
	viewContactRedux
};
